import React from 'react';

import { TAppProviderProps } from '@/shared/app/provider/provider.types';
import { AuthLoader } from '@/shared/components/ui/auth-loader/auth-loader';
import { FullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader';

export const AppProvider: React.FC<TAppProviderProps> = ({ children }) => {
  //useIdleRefresh(); TODO! implement cache invalidation from vite

  return (
    <AuthLoader renderLoading={() => <FullscreenLoader />}>
      {children}
    </AuthLoader>
  );
};
